// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff44d364","453":"d8df77a1","455":"66c40079"}[chunkId] + ".chunk.js";
};